/**
 * Branch Inventory API Client
 * Frontend API calls for branch inventory management
 */

import apiClient from './client';

/**
 * Get inventory for a branch
 */
export const getBranchInventory = async (branchId, params = {}) => {
  const response = await apiClient.get(`/branches/${branchId}/inventory`, { params });
  return response.data;
};

/**
 * Get specific product stock in branch
 */
export const getProductStock = async (branchId, productId) => {
  const response = await apiClient.get(`/branches/${branchId}/inventory/${productId}`);
  return response.data;
};

/**
 * Adjust stock (add or remove)
 */
export const adjustStock = async (branchId, productId, adjustment, reason) => {
  const response = await apiClient.post(`/branches/${branchId}/inventory/adjust`, {
    productId,
    adjustment,
    reason
  });
  return response.data;
};

/**
 * Bulk adjust stock (for stock takes)
 */
export const bulkAdjustStock = async (branchId, adjustments, reason) => {
  const response = await apiClient.post(`/branches/${branchId}/inventory/bulk-adjust`, {
    adjustments,
    reason
  });
  return response.data;
};

/**
 * Get low stock items
 */
export const getLowStockItems = async (branchId, limit = 20) => {
  const response = await apiClient.get(`/branches/${branchId}/inventory/low-stock`, {
    params: { limit }
  });
  return response.data;
};

/**
 * Get low stock count (for dashboard badge)
 */
export const getLowStockCount = async (branchId) => {
  const response = await apiClient.get(`/branches/${branchId}/inventory/low-stock-count`);
  return response.data;
};

/**
 * Get stock movements/history
 */
export const getStockMovements = async (branchId, params = {}) => {
  const response = await apiClient.get(`/branches/${branchId}/inventory/movements`, { params });
  return response.data;
};

/**
 * Get total inventory value
 */
export const getBranchInventoryValue = async (branchId) => {
  const response = await apiClient.get(`/branches/${branchId}/inventory/value`);
  return response.data;
};

/**
 * Initialize inventory for products in branch
 * Accepts array of {productId, quantity} objects or just productIds (for backward compatibility)
 */
export const initializeBranchInventory = async (branchId, products) => {
  const response = await apiClient.post(`/branches/${branchId}/inventory/initialize`, {
    productIds: products
  });
  return response.data;
};

export default {
  getBranchInventory,
  getProductStock,
  adjustStock,
  bulkAdjustStock,
  getLowStockItems,
  getLowStockCount,
  getStockMovements,
  getBranchInventoryValue,
  initializeBranchInventory
};
